export default __webpack_public_path__ + "static/mouad-aec835b66a2c9b76ab9441f0fda7ac24.jpg";